<div class="flex items-center justify-between p-4 border-b">
	<div class="flex items-center gap-4">
		<ui-button
			preset="EXTRA_LOW_EMPHASIS"
			icon="arrow-back"
			[label]="viewModel_().backLabel"
			(click)="goBack()"
			[testHook]="testHooks.Button"
		/>

		<span class="h2" [testHook]="testHooks.Title">{{
			viewModel_().title
		}}</span>

		<app-intake-status-display />
	</div>

	<div class="flex gap-4 items-center">
		@if (viewModel_().inviteStatus.isDraft) {
			<div class="text-xs text-gray-500">1 of 2</div>

			@if (canUseEmailIntegration_()) {
				<ui-button
					preset="EXTRA_LOW_EMPHASIS"
					label="Cancel"
					(click)="cancelIntake()"
					[testHook]="testHooks.Button2"
					[disabled]="!viewModel_().portalInvite"
				/>
			}

			<ui-button
				preset="HIGH_EMPHASIS"
				[rightIcon]="nextBtnIcon_()"
				label="Next"
				(click)="sendIntakeEmail()"
				[testHook]="testHooks.Button2"
				[disabled]="!viewModel_().inviteContainsInvitees"
			/>
		} @else if (viewModel_().inviteStatus.isActive) {
			<ui-button
				label="Send follow-up"
				icon="mail"
				(click)="sendIntakeFollowUpEmail()"
			/>

			<ui-dropdown [items]="kebabItems">
				<ui-button
					dropdown-trigger
					preset="EXTRA_LOW_EMPHASIS"
					icon="dots-vertical"
				/>
			</ui-dropdown>
		}
	</div>
</div>
